import { useDispatch, useSelector } from 'react-redux';
import { setConfig, translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { useApiQuery } from './useApiQuery';

const useConfigSources = ({ configKey, options }) => {
  const dispatch = useDispatch();

  const trans = useSelector(translator);
  const configSourceApi = useSelector((state) => state.apis.configSourceApi);

  const queryOptions = {
    enabled: !!configKey,
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  };

  return useApiQuery(
    ['configData', configKey],
    () =>
      new Promise((resolve, reject) => {
        configSourceApi.getConfigSourceByKey(
          configKey,
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              const config = data?.data;
              dispatch(setConfig({ [configKey]: config }));
              resolve(config);
            },
            errorCallback: () => {
              reject(null);
            },
          })
        );
      }),
    queryOptions
  );
};

export default useConfigSources;
